export default __webpack_public_path__ + "static/media/arrow-right-white.535d0791.svg";